import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=3e3c0e2a&scoped=true"
import script from "./paging.vue?vue&type=script&lang=js"
export * from "./paging.vue?vue&type=script&lang=js"
import style0 from "./paging.vue?vue&type=style&index=0&id=3e3c0e2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3c0e2a",
  null
  
)

export default component.exports